export default function SkillCard({ title, items, icon }) {
return (
<div className="rounded-2xl border border-white/10 bg-white/[0.03] p-5 hover:bg-white/[0.05] transition">
<h3 className="font-semibold mb-2 flex items-center gap-2 font-mono">{icon} {title}</h3>
<ul className="space-y-1 text-slate-300 text-sm list-disc list-inside">
{items.map((it) => (<li key={it}>{it}</li>))}
</ul>
</div>
);
}